import classNames from "classnames";
import pluralize from "pluralize";
import {useState} from "react";
import {FiArrowRight, FiInfo} from "react-icons/fi";

import {Chip} from "@/components/chip/Chip.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {LinkedSchedulesModal} from "@/components/multiServiceSelect/LinkedSchedulesModal.tsx";

import styles from "./LinkedSchedulesChip.module.scss";

interface LinkedSchedulesChipProps {
  checkId: number;
  checkName: string;
  count: number;
  excludeScheduleId?: number;
}

export const LinkedSchedulesChip = ({checkId, checkName, count, excludeScheduleId}: LinkedSchedulesChipProps) => {
  const [showModal, setShowModal] = useState(false);

  if (count === 0) return null;

  return (
    <>
      <Chip
        variant="tag"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setShowModal(true);
        }}
        className={classNames(styles.linkedSchedulesChip, "d-flex gap-1")}
      >
        <Icon icon={FiInfo} size="chip" />
        In {count} {pluralize("Schedule", count)}
        <Icon icon={FiArrowRight} size="chip" />
      </Chip>
      {/* Used to capture all click events to stop propagation down to the select option on closing the modal*/}
      <div role={"none"} onClick={(e) => e.stopPropagation()}>
        <LinkedSchedulesModal
          show={showModal}
          onHide={() => setShowModal(false)}
          checkId={checkId}
          checkName={checkName}
          excludeScheduleId={excludeScheduleId}
        />
      </div>
    </>
  );
};
